import { render } from "./AdminArticle.vue?vue&type=template&id=0b0128dc"
import script from "./AdminArticle.vue?vue&type=script&lang=js"
export * from "./AdminArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__